import { createIconComponent } from '../../factory/create-icon-component';
export const ArrowDownIcon = createIconComponent(
  'ArrowDownIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3L12 21M12 21L19 14M12 21L5 14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
